import { Component } from '@angular/core';
import { Alert } from '../../models/Alert';
import { AlertService } from '../../services/alert.service';

import { CommonModule } from '@angular/common';
@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css'],
    imports: [CommonModule]
})
export class AlertComponent {
  alertMessage: string = '';
  alerTitle: string = '';
  alertType: string = '';
  alertCenter: boolean = false;
  showDescription: boolean = false;
  alertObject: Alert = {
    alertMessage: '',
    alertType: '',
    alertCenter: false,
    alerTitle: '',
    duration: 0,
  };

  constructor(private alertService: AlertService) {}

  ngOnInit(): void {
    const errorString = localStorage.getItem('AlertObject');
    if (errorString !== 'undefined' && errorString !== null) {
      this.alertObject = JSON.parse(errorString);
      this.loadAlertSessionStorage(this.alertObject);
    }
    this.loadAlert();
  }

  loadAlert() {
    this.alertService.alertState$.subscribe((alertState) => {
      this.alertType = alertState.alertType;
      this.alertCenter = alertState.alertCenter;
      this.alerTitle =
        alertState.alerTitle !== undefined ? alertState.alerTitle : 'Error';
      this.alertMessage = alertState.alertMessage;
      const duration =
        alertState.duration !== undefined ? alertState.duration : 0;
      this.setDuration(duration);
    });
  }

  loadAlertSessionStorage(alertObject: Alert) {
    this.alertType = alertObject.alertType;
    this.alertCenter = alertObject.alertCenter;
    this.alerTitle = alertObject.alerTitle ?? 'Error';
    this.alertMessage = alertObject.alertMessage;
    const duration = alertObject.duration ?? 0;
    this.setDuration(duration);
  }

  setDuration(duration: number) {
    if (this.alertMessage && duration > 0) {
      setTimeout(() => {
        this.cerrarAlerta();
      }, duration);
    }
  }

  cerrarAlerta() {
    this.alertMessage = '';
    localStorage.setItem('AlertObject', JSON.stringify(undefined));
  }
}
